import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import {
  dropTipoCat,
  dropIniciativaCat,
  dropLocalCat,
  dropLateralidadeCat,
  dropOrgaoDeClasse,
  dropBoolean,
} from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Cat = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const cat = pessoal?.Cat ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalCat',
      id: item?.id,
      pessoal_id: pessoal?.id,
      cat_id: item?.cat_id || null,
      tpcat: item?.tpcat || null,
      iniciatcat: item?.iniciatcat || null,
      nrreccatorig: item?.nrreccatorig || '',
      dtacid: item?.dtacid || null,
      situacao_geradora_id: item?.situacao_geradora_id || null,
      tplocal: item?.tplocal || null,
      dsclocal: item?.dsclocal || '',
      parte_corpo_id: item?.parte_corpo_id || null,
      lateralidade: item?.lateralidade || null,
      agente_causador_id: item?.agente_causador_id || null,
      dtatendimento: item?.dtatendimento || null,
      indinternacao: item?.indinternacao || null,
      durtrat: item?.durtrat || '',
      codcnes: item?.codcnes || '',
      natureza_lesao_id: item?.natureza_lesao_id || null,
      diagprovavel: item?.diagprovavel || '',
      codcid: item?.codcid || '',
      indafast: item?.indafast || null,
      obscat: item?.obscat || '',
      indcatobito: item?.indcatobito || null,
      dtobito: item?.dtobito || null,
      indcomunpolicia: item?.indcomunpolicia || null,
      nmemit: item?.nmemit || '',
      ideoc: item?.ideoc || null,
      nroc: item?.nroc || '',
      ufoc_id: item?.ufoc_id || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação da CAT" disableMargin />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            label="CAT"
            name="cat_id"
            control={control}
            options={drops?.Cat}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tpcat"
            control={control}
            label="Tipo de CAT"
            options={dropTipoCat}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="iniciatcat"
            control={control}
            options={dropIniciativaCat}
            label="Iniciativa da Emissão da CAT"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            control={control}
            name="nrreccatorig"
            options={dropIniciativaCat}
            label="Nº do Recibo da CAT Original"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Dados do Acidente / Doença" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            name="dtacid"
            control={control}
            label="Data do Acidente"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Dropdown
            control={control}
            label="Situação Geradora"
            name="situacao_geradora_id"
            options={drops?.SituacaoGeradora}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tplocal"
            control={control}
            options={dropLocalCat}
            label="Tipo de Local do Acidente"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input
            name="dsclocal"
            control={control}
            label="Descrição do Local do Acidente"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            control={control}
            name="parte_corpo_id"
            options={drops?.ParteCorpo}
            label="Parte do Corpo Atingida"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            control={control}
            name="lateralidade"
            label="Lado Atingido"
            options={dropLateralidadeCat}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            label="Agente Causador"
            name="agente_causador_id"
            options={drops?.AgenteCausador}
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Atendimento / Lesão / Tratamento" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            control={control}
            name="dtatendimento"
            label="Data do Atendimento"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            label="Internação"
            name="indinternacao"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            name="durtrat"
            control={control}
            label="Duração do Tratamento"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input name="codcnes" control={control} label="Código CNES" />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Dropdown
            control={control}
            name="natureza_lesao_id"
            label="Natureza da Lesão"
            options={drops?.NaturezaLesao}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input
            control={control}
            name="diagprovavel"
            label="Diagnóstico Provável"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input name="codcid" control={control} label="Código CID" />
        </Grid>
        <Grid item xs={12}>
          <Title title="Consequências / Afastamento / Óbito" />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="indafast"
            control={control}
            label="Afastamento"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            label="Óbito"
            control={control}
            name="indcatobito"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            name="dtobito"
            control={control}
            label="Data de Óbito"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            control={control}
            options={dropBoolean}
            name="indcomunpolicia"
            label="Comunicação à Polícia"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            name="obscat"
            control={control}
            label="Observação"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Emitente / Dados Médicos" />
        </Grid>
        <Grid item xs={12}>
          <Input name="nmemit" label="Emitente" control={control} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="ideoc"
            control={control}
            label="Órgão de Classe"
            options={dropOrgaoDeClasse}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            name="nroc"
            control={control}
            label="Nº de Registro no Órgão de Classe"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="ufoc_id"
            control={control}
            options={drops?.UF}
            label="UF do Órgão de Classe"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Comunicações de Acidente de Trabalho"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Cat')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={cat}
          columns={[
            {
              field: 'cat',
              headerName: 'CAT',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'tpcat',
              headerName: 'Tipo',
              minWidth: 200,
              sortable: false,
            },
            {
              field: 'dtacid',
              headerName: 'Data do Acidente',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'situacao_geradora',
              headerName: 'Situação Geradora',
              minWidth: 200,
              sortable: false,
            },
            {
              field: 'indafast',
              headerName: 'Afastamento',
              width: 120,
              type: 'boolean',
              sortable: false,
              valueGetter: ({ row }) => row?.indafast === 'SIM',
            },
            {
              field: 'indcatobito',
              headerName: 'Óbito',
              width: 120,
              type: 'boolean',
              sortable: false,
              valueGetter: ({ row }) => row?.indcatobito === 'SIM',
            },
            {
              field: 'nmemit',
              headerName: 'Emitente',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() => openDialog(<Modal item={row} />, 'Editar Cat')}
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalCat', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Cat;
